// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "The classic, back-of-the-paper news quiz, retooled for the digital era.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Super quiz",
  id: "super-quiz",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/super-quiz/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "SuperQuizConfigTool" */ "app/components/tools/SuperQuizConfigTool/SuperQuizConfigTool"),
    loading: DynamicImportLoader,
    modules: ["SuperQuizConfigTool"]
  })
};

export default CONFIG;
